import { useEffect, useRef, useState } from "react";
import styles from "../Filters.module.scss";
import { SearchInput } from "@components/templates/SearchInput";
import { X } from "react-feather";

export const SingleFilter = ({ filterData, payload, onChangeHandler, isDisabled, pendoEventHandler }) => {
  const [showFilter, setShowFilter] = useState(false);
  const [filterName, setFilterName] = useState("");
  const [search, setSearch] = useState("");
  const [filterCount, setFilterCount] = useState(0);

  const divRef = useRef(null);

  useEffect(() => {
    if (filterData && Object.keys(filterData)) {
      setFilterName(Object.keys(filterData)[0]);
    }
  }, [filterData]);

  useEffect(() => {
    let count = 0;
    if (payload && payload?.filters) {
      Object.values(payload.filters).map((filterItem) => {
        if (filterItem.length > 0) {
          count = count + filterItem.length;
        }
      });
      setFilterCount(count);
    }
  }, [payload]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  });

  const handleClickOutside = (e) => {
    if (showFilter && !divRef?.current?.contains(e.target)) {
      setShowFilter(false);
    }
  };

  const onSearchHandler = (value) => {
    setSearch(value);
  };

  return (
    <div ref={divRef} className="position-relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          setShowFilter(true);
          if (pendoEventHandler) {
            pendoEventHandler();
          }
        }}
        className={styles.filterButton}>
        <span className="material-symbols-outlined">tune</span>
        <span className="ml-1">Filter by Tags</span>
        {filterCount > 0 ? (
          <span className={`ml-2 ${styles.filter_count}`}>
            {filterCount}
            <X
              className="cursor-pointer"
              onClick={(e) => {
                e.stopPropagation();
                onChangeHandler("", "", "clearAll");
              }}
              size={16}
            />
          </span>
        ) : (
          <></>
        )}
      </button>
      {showFilter ? (
        <div onClick={(e) => e.stopPropagation()} className={styles.singleFilterContainer}>
          <div className="mb-2">
            <SearchInput value={search} onSearchHandler={onSearchHandler} />
          </div>
          {filterData &&
            filterData?.[filterName]?.length &&
            filterData[filterName].map(
              (filter) =>
                filter &&
                filter.toLowerCase().includes(search.toLowerCase()) && (
                  <label key={filter} className="form-check ml-2">
                    <input disabled={isDisabled} className="form-check-input" checked={payload.filters[filterName].includes(filter)} onChange={() => onChangeHandler(filterName, filter)} type="checkbox" /> {/*onchange to be checked */}
                    <span className="form-check-label">{filter}</span>
                  </label>
                )
            )}
        </div>
      ) : null}
    </div>
  );
};
